// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"058adc21","732":"0963f67d","977":"021e1604"}[chunkId] + ".chunk.js";
};